import React from 'react'
import { Link } from 'react-router-dom'

import { useAppContext } from './AppContext.jsx'
import { CookieSettingsLink } from './CookieConsent.jsx'

import appLogoHorizontal from '../assets/app_logo_horizontal.png'
import es from '../locales/mainPage_es.json'
import en from '../locales/mainPage_en.json'
import './PageCommon.css'

export function PageHeader() {
    const { lang, setLang, getLanguageObject } = useAppContext();
    const t = getLanguageObject(lang, es, en);

    return (
        <>
            {/* <!-- ── NAV ──────────────────────────────────────────── --> */}
            <nav>
                <div className="nav-inner">
                    <Link to="/" className="nav-logo">
                        <img src={appLogoHorizontal} alt="FynApp logo horizontal" className="nav-logo-img" onError={(e) => { e.currentTarget.style.display = 'none'; e.currentTarget.nextSibling.style.display = 'flex'; }} />
                        <span className="nav-logo-text">{t.footer.brand}</span>
                    </Link>
                    <ul className="nav-links">
                        <li><Link to="/how-it-works">{t.nav.howItWorks}</Link></li>
                        <li><Link to="/features">{t.nav.features}</Link></li>
                        <li><Link to="/benefits">{t.nav.benefits}</Link></li>
                        <li><Link to="/testimonials">{t.nav.testimonials}</Link></li>
                        <li><Link to="/pricing">{t.nav.pricing}</Link></li>
                        <li><Link to="/faq">{t.nav.faq}</Link></li>
                    </ul>
                    <div className="nav-actions">
                        <div className="lang-switcher">
                            <button
                                className={`lang-btn ${lang === 'es' ? 'active' : ''}`}
                                onClick={() => setLang('es')}
                            >
                                ES
                            </button>
                            <span className="lang-divider">|</span>
                            <button
                                className={`lang-btn ${lang === 'en' ? 'active' : ''}`}
                                onClick={() => setLang('en')}
                            >
                                EN
                            </button>
                        </div>
                        <button className="btn-nav-login">{t.nav.login}</button>
                        <button className="btn-nav-cta">{t.nav.startFree}</button>
                    </div>
                </div>
            </nav>
        </>
    )
}

export function PageFooter() {
    const { lang, getLanguageObject } = useAppContext();
    const t = getLanguageObject(lang, es, en);

    return (
        <>
            {/* <!-- ── FOOTER ─────────────────────────────────────────── --> */}
            <footer>
                <div className="footer-inner">
                    <div className="footer-brand">
                        <img src={appLogoHorizontal} alt="FynApp logo horizontal" className="nav-logo-img" onError={(e) => { e.currentTarget.style.display = 'none'; e.currentTarget.nextSibling.style.display = 'block'; }} />
                        <span className="footer-logo-text">{t.footer.brand}</span>
                        <p className="footer-tagline">{t.footer.tagline}</p>
                    </div>
                    <div className="footer-col">
                        <h4>{t.footer.col1Title}</h4>
                        <ul>
                            <li><Link to="/how-it-works">{t.footer.col1Items[0]}</Link></li>
                            <li><Link to="/features">{t.footer.col1Items[1]}</Link></li>
                            <li><Link to="/benefits">{t.footer.col1Items[2]}</Link></li>
                            <li><Link to="/testimonials">{t.footer.col1Items[3]}</Link></li>
                            <li><Link to="/pricing">{t.footer.col1Items[4]}</Link></li>
                            <li><Link to="/faq">{t.footer.col1Items[5]}</Link></li>
                        </ul>
                    </div>
                    <div className="footer-col">
                        <h4>{t.footer.col2Title}</h4>
                        <ul>
                            <li><Link to="/about-us">{t.footer.col2Items[0]}</Link></li>
                            <li><Link to="/blog">{t.footer.col2Items[1]}</Link></li>
                            <li><Link to="/contact">{t.footer.col2Items[2]}</Link></li>
                            <li><Link to="/for-professionals">{t.footer.col2Items[3]}</Link></li>
                        </ul>
                    </div>
                    <div className="footer-col">
                        <h4>{t.footer.col3Title}</h4>
                        <ul>
                            <li><Link to="/privacy">{t.footer.col3Items[0]}</Link></li>
                            <li><Link to="/terms-of-use">{t.footer.col3Items[1]}</Link></li>
                            <li><Link to="/security">{t.footer.col3Items[2]}</Link></li>
                            <li><Link to="/medical-disclaimer">{t.footer.col3Items[3]}</Link></li>
                        </ul>
                    </div>
                </div>
                <div className="footer-bottom">
                    <span>
                        {t.footer.bottomText}
                        {' · '}
                        <CookieSettingsLink />
                    </span>
                    <div className="footer-social">
                        <a
                            href="https://x.com/mediabroscom"
                            className="social-icon"
                            target="_blank"
                            rel="noopener noreferrer"
                        >𝕏</a>
                        <a
                            href="https://www.linkedin.com/company/mediabros"
                            className="social-icon"
                            target="_blank"
                            rel="noopener noreferrer"
                        >in</a>
                        {/* <a href="#" className="social-icon">📷</a> */}
                    </div>
                </div>
            </footer>
        </>
    )
}

export function SectionContainer({
    children,
    sectionClassName = '',
    sectionId = '',
    containerClassName = '',
    containerId = ''
}) {
    return (
        <section className={`section ${sectionClassName}`} id={sectionId}>
            <div className={`container ${containerClassName}`} id={containerId}>
                {children}
            </div>
        </section>
    )
}

export function SetAnchor({ id }) {
    return (
        <a id={id}></a>
    )
}